import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";

export const focusTool = createViewerAction(ViewerMethod.IMAGE_TOOLS_FOCUS);

export const reconfigureTools = createViewerAction(
  ViewerMethod.IMAGE_TOOLS_RECONFIGURE
);
